import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [activeTab, setActiveTab] = useState<'general' | 'application'>('general');
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = {
    general: [{
      question: 'Are you a lender?',
      answer: 'No, we are a brokerage. This works in your favor because we force our network of 75+ lenders to compete for your business, ensuring you get the best possible rates and terms.'
    }, {
      question: 'How much funding can I get?',
      answer: 'Funding amounts range from $5,000 up to $5,000,000 depending on your business revenue, time in business, and the specific funding product you qualify for.'
    }, {
      question: 'Does applying hurt my credit?',
      answer: 'No. We perform a soft credit pull to check your eligibility, which does not affect your credit score. A hard pull is typically only done once you accept an offer and proceed to funding.'
    }, {
      question: 'How fast can I get funded?',
      answer: 'Speed is our specialty. Most approvals happen within a few hours, and funds can be deposited into your account as soon as the same business day.'
    }],
    application: [{
      question: 'What documents do I need?',
      answer: 'To start, we typically only need a completed application and your last 3 months of business bank statements. For larger amounts, tax returns or P&L statements may be requested.'
    }, {
      question: 'Do I need collateral?',
      answer: 'Most of our funding options are unsecured, meaning no physical collateral (like real estate or equipment) is required.'
    }, {
      question: 'Can I get funded with bad credit?',
      answer: 'Yes! We have programs specifically designed for business owners with challenged credit. As long as your business is generating revenue, we likely have a solution for you.'
    }]
  };
  return <section id="faq" className="py-20 bg-gray-50" data-id="element-161">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="text-center mb-12" data-id="element-163">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-164">
            Answers to Your Funding Questions
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-8" data-id="element-165">
          <div className="bg-white p-1 rounded-lg border border-gray-200 inline-flex" data-id="element-166">
            <button onClick={() => {
            setActiveTab('general');
            setOpenIndex(null);
          }} className={`px-6 py-2 rounded-md text-sm font-medium transition-all ${activeTab === 'general' ? 'bg-[#00E676] text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-167">
              General Questions
            </button>
            <button onClick={() => {
            setActiveTab('application');
            setOpenIndex(null);
          }} className={`px-6 py-2 rounded-md text-sm font-medium transition-all ${activeTab === 'application' ? 'bg-[#00E676] text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-168">
              Application Process
            </button>
          </div>
        </div>

        {/* Accordion */}
        <div className="space-y-4" data-id="element-169">
          {faqs[activeTab].map((item, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden transition-all duration-200 hover:shadow-md" data-id="element-170">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-171">
                <span className="font-semibold text-gray-900" data-id="element-172">
                  {item.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#00E676]" data-id="element-173" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-174" />}
              </button>

              <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-175">
                <div className="p-5 pt-0 text-gray-600 border-t border-gray-50 mt-2" data-id="element-176">
                  {item.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}